// The Anthropic API key itself lives server-side only (a Supabase Edge
// Function secret, see supabase/functions/describe-medicine) — the browser
// never sees or stores it. This file just remembers the user's model
// preference, which is not sensitive.
const MODEL_STORAGE_KEY = 'medai.ai.anthropicModel';

// Lab document recognition is transcription, not open-ended clinical advice.
// Start new installations with the fast model; users who intentionally choose
// another model in Settings still keep that explicit choice.
export const DEFAULT_ANTHROPIC_MODEL = 'claude-haiku-4-5';
export const ANTHROPIC_MODEL_OPTIONS = [
  { value: 'claude-opus-5', label: 'Claude Opus 5 (умнее, дороже)' },
  { value: 'claude-sonnet-5', label: 'Claude Sonnet 5 (баланс)' },
  { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5 (быстрее и дешевле)' },
] as const;

export function getAnthropicModel(): string {
  return localStorage.getItem(MODEL_STORAGE_KEY) || DEFAULT_ANTHROPIC_MODEL;
}

export function setAnthropicModel(model: string): void {
  localStorage.setItem(MODEL_STORAGE_KEY, model);
}
